module.exports = __webpack_public_path__ + "visa.png?df2eb2e0550be67ad12b3090648483dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paymentIcons/visa.png
// module id = 369
// module chunks = 0